const Meta = [
  {
    name: 'EMAIL',
    sample: 'Automations_Export_DataStructure_Sample_EMAIL',
    attribute: null
  },
  {
    name: 'PHONE',
    sample: 'Automations_Export_DataStructure_Sample_PHONE',
    attribute: null
  },
  {
    name: 'GEN',
    sample: 'Automations_Export_DataStructure_Sample_GENDER',
    attribute: null
  },
  {
    name: 'DOBY',
    sample: 'Automations_Export_DataStructure_Sample_DOBY',
    attribute: null
  },
  {
    name: 'DOBM',
    sample: 'Automations_Export_DataStructure_Sample_DOBM',
    attribute: null
  },
  {
    name: 'DOBD',
    sample: 'Automations_Export_DataStructure_Sample_DOBD',
    attribute: null
  },
  {
    name: 'FN',
    sample: 'Automations_Export_DataStructure_Sample_FN',
    attribute: null
  },
  {
    name: 'LN',
    sample: 'Automations_Export_DataStructure_Sample_LN',
    attribute: null
  },
  {
    name: 'FI',
    sample: 'Automations_Export_DataStructure_Sample_FI',
    attribute: null
  },
  {
    name: 'ST',
    sample: 'Automations_Export_DataStructure_Sample_ST',
    attribute: null
  },
  {
    name: 'CT',
    sample: 'Automations_Export_DataStructure_Sample_CT',
    attribute: null
  },
  {
    name: 'ZIP',
    sample: 'Automations_Export_DataStructure_Sample_ZIP',
    attribute: null
  },
  {
    name: 'COUNTRY',
    sample: 'Automations_Export_DataStructure_Sample_COUNTRY',
    attribute: null
  },
  {
    name: 'MADID',
    sample: 'Automations_Export_DataStructure_Sample_MADID',
    attribute: null
  }
]

const Google = [
  { name: 'hashed_email', sample: '', attribute: null },
  { name: 'hashed_first_name', sample: '', attribute: null },
  { name: 'hashed_last_name', sample: '', attribute: null },
  { name: 'country_code', sample: '', attribute: null },
  { name: 'postal_code', sample: '', attribute: null },
  { name: 'city', sample: '', attribute: null },
  { name: 'state', sample: '', attribute: null },
  { name: 'hashed_street_address', sample: '', attribute: null }
]

const TranslationsGoogle = Object.freeze({
  hashed_email: 'Automations_Export_DataStructure_Label_Email',
  hashed_first_name: 'Automations_Export_DataStructure_Label_FirstName',
  hashed_last_name: 'Automations_Export_DataStructure_Label_LastName',
  country_code: 'Automations_Export_DataStructure_Label_CountryCode',
  postal_code: 'Automations_Export_DataStructure_Label_PostalCode',
  city: 'Automations_Export_DataStructure_Label_City',
  state: 'Automations_Export_DataStructure_Label_State',
  hashed_street_address: 'Automations_Export_DataStructure_Label_StreetAddress'
})

export { Meta, Google, TranslationsGoogle }



// WEBPACK FOOTER //
// ./src/modules/automations/enum/DataStructureScheme.js